import getApiClient from "./../../../../../shared/api";
import {
  showInfo,
  showError,
  clearNotifications,
  showWarning
} from "../../../../../notifications/ducks/actions";

const url = "/film";

export const FETCH_SET_DRESSING_OVERVIEW = "FETCH_SET_DRESSING_OVERVIEW";
export const SAVE_ALIAS_SET_DRESSING = "SAVE_ALIAS_SET_DRESSING";
export const ALIAS_SET_DRESSING = "ALIAS_SET_DRESSING";
export const SAVE_REMOVE_ALIAS_SET_DRESSING = "SAVE_REMOVE_ALIAS_SET_DRESSING";
export const UNALIAS_SET_DRESSING = "UNALIAS_SET_DRESSING";
export const DELETE_MULTIPLE_SET_DRESSINGS = "DELETE_MULTIPLE_SET_DRESSINGS";

export function fetchSetDressingOverview(id) {
  return (dispatch) => {
    dispatch({
      type: FETCH_SET_DRESSING_OVERVIEW,
      payload: getApiClient().get(`${url}/${id}/SetDressing/Overview`)
    });
  };
}

export function aliasSetDressing(filmId, aliasSetDressing, mainSetDressing) {
  return (dispatch) => {
    dispatch({
      type: SAVE_ALIAS_SET_DRESSING,
      payload: getApiClient().put(
        `${url}/${filmId}/SetDressing/${mainSetDressing.id}/Alias`,
        { aliasId: aliasSetDressing.id }
      ),
      meta: { aliasSetDressing, mainSetDressing }
    })
      .then((response) => {
        dispatch({
          type: ALIAS_SET_DRESSING,
          meta: { aliasSetDressing, mainSetDressing }
        });
        dispatch(
          showInfo(`Aliased ${aliasSetDressing.name} with ${mainSetDressing.name}`)
        );
      })
      .catch((response) => {
        dispatch(
          showError(
            `Error aliasing ${aliasSetDressing.name} with ${mainSetDressing.name}`
          )
        );
      })
      .then((response) => {
        dispatch(clearNotifications());
      });
  };
}

export function unaliasSetDressing(filmId, aliasSetDressing, mainSetDressing) {
  return (dispatch) => {
    dispatch({
      type: SAVE_REMOVE_ALIAS_SET_DRESSING,
      payload: getApiClient().put(
        `${url}/${filmId}/SetDressing/${mainSetDressing.id}/RemoveAlias`,
        { aliasId: aliasSetDressing.id }
      ),
      meta: { aliasSetDressing, mainSetDressing }
    })
      .then((response) => {
        dispatch({
          type: UNALIAS_SET_DRESSING,
          meta: { aliasSetDressing, mainSetDressing }
        });
        dispatch(
          showInfo(
            `Removed alias ${aliasSetDressing.name} from ${mainSetDressing.name}`
          )
        );
      })
      .catch((response) => {
        dispatch(
          showError(
            `Error removing alias ${aliasSetDressing.name} from ${mainSetDressing.name}`
          )
        );
      })
      .then((response) => {
        dispatch(clearNotifications());
      });
  };
}
export function deleteMultipleSetDressings(filmId, setDressingIds) {
  return (dispatch) => {
    dispatch({
      type: DELETE_MULTIPLE_SET_DRESSINGS,
      payload: getApiClient().post(`/film/${filmId}/setDressing/deleteMultiple`, { setDressingIds }),
      meta: { setDressingIds }
    })
      .then((response) => {
        dispatch(showInfo(`Deleted ${setDressingIds.length} set dressing(s)`));
      })
      .catch((response) => {
        dispatch(showError(`Error deleting set dressings`));
      })
      .then((response) => {
        dispatch(clearNotifications());
      });
  };
}